const teacherUser = {
  id: '3ca24580-418a-11e8-9767-5140ef81dff3',
  email: 'craig@ringmarketing.net',
  username: 'craig@ringmarketing.net',
  firstName: 'Test',
  lastName: 'Teacher',
  fullName: 'Test Teacher',
  lastModified: 1521738144176,
  created: 1521738144176,
  role: 'Teacher',
  isTeacher: true,
  schoolDistrict: 'c85d02d0-2ff2-11e8-bb3c-cb20d31ae9b7',
  school: 'f6365530-310a-11e8-ae0c-5fd82a1b2893',
}

export default teacherUser


// WEBPACK FOOTER //
// ./src/helpers/users/testing/teacherUser.js